import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  UrlTree
} from '@angular/router';
import { PermissionService } from '@cv-invision/core';
import { PERMISSION } from '../../../inbox/model/permission.model';

@Injectable({ providedIn: 'root' })
export class ManageQueuesDocumentLoaderGuard implements CanActivate {
  constructor(
    private router: Router,
    private userPermission: PermissionService
  ) {}

  canActivate(): boolean | UrlTree {
    // If user does NOT have permission, redirect to /intelligence/inbox
    const allowed = this.userPermission.hasPermission(PERMISSION.QUEUES_MANAGER);

    if (!allowed) {
      // Absolute target: returns a UrlTree instead of navigating
      return this.router.createUrlTree(['/intelligence/inbox']);
      // (Equivalent) return this.router.parseUrl('/intelligence/inbox');
    }

    return true;
  }
}